import React from 'react';
import { TEST_IDS } from '../constants/testIds';

const STEPS = [
  {
    n: '01',
    title: 'Open The Alexa App',
    body: (
      <>On your phone, open the Amazon Alexa app and tap More → Skills &amp; Games.</>
    ),
  },
  {
    n: '02',
    title: 'Search "OSO London"',
    body: (
      <>Find our skill and tap <em>Enable To Use</em>.</>
    ),
  },
  {
    n: '03',
    title: 'Speak To Your Echo',
    body: (
      <>Say <em>&ldquo;Alexa, play OSO London&rdquo;</em>. Pause anytime with <em>&ldquo;Alexa, stop&rdquo;</em>.</>
    ),
  },
];

const AlexaHeader = () => (
  <>
    <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70">
      ::  Voice  ·  Alexa Skill  ::
    </div>
    <h1 className="font-display text-6xl md:text-8xl mt-4">ALEXA</h1>
    <p
      data-testid={TEST_IDS.alexaInvocation}
      className="font-mono-r text-xs md:text-sm tracking-[0.25em] uppercase opacity-70 mt-3"
    >
      Say · &ldquo;Alexa, play OSO London&rdquo;
    </p>
  </>
);

const AlexaQuote = () => (
  <blockquote className="hairline w-full max-w-2xl p-8 text-left">
    <div className="font-mono-r text-[10px] tracking-[0.4em] uppercase opacity-60">Try it</div>
    <p className="font-display text-4xl md:text-5xl mt-3 leading-tight">
      &ldquo;Alexa,<br />play OSO London.&rdquo;
    </p>
    <p className="font-mono-r text-xs mt-6 opacity-75 leading-relaxed">
      OSO London ships with a custom Amazon Alexa Skill that plays our
      live stream on any Echo, Echo Dot, Echo Show or Alexa-enabled
      device. Once enabled in the Alexa app, simply ask out loud.
    </p>
  </blockquote>
);

const AlexaStep = ({ n, title, body }) => (
  <div>
    <div className="font-mono-r text-[10px] tracking-[0.4em] uppercase opacity-60">Step {n}</div>
    <h3 className="font-display text-3xl mt-1">{title}</h3>
    <p className="font-mono-r text-sm mt-2 opacity-85">{body}</p>
  </div>
);

const AlexaTuneIn = () => (
  <div className="w-full max-w-2xl text-left">
    <div className="hairline p-4">
      <div className="flex items-center justify-between mb-3">
        <span className="font-mono-r text-[10px] tracking-[0.3em] uppercase opacity-60">Also On</span>
      </div>
      <a
        data-testid="alexa-tunein-link"
        href="https://tunein.com/radio/OSO-London-s357544/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center py-4 hover:opacity-70 transition-opacity"
        aria-label="Listen to OSO London on TuneIn"
      >
        <img src="/tunein-logo.png" alt="TuneIn" className="h-10 md:h-12 w-auto" />
      </a>
    </div>
  </div>
);

export default function Alexa() {
  return (
    <section className="w-full flex flex-col items-center text-center fade-up">
      <AlexaHeader />
      <div className="ascii-divider my-10">─  ─  ─  ─  ─</div>
      <AlexaQuote />
      <div className="ascii-divider my-10">·  ·  ·  ·  ·</div>
      <div className="w-full max-w-2xl text-left space-y-6">
        {STEPS.map((step) => (
          <AlexaStep key={step.n} {...step} />
        ))}
      </div>
      <div className="ascii-divider my-12">·  ·  ·  ·  ·</div>
      <AlexaTuneIn />
    </section>
  );
}
